import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { Subscription } from 'rxjs'
import { OrganizationsService } from '../../services/organizations.service'
import { UploadGallaryImagesComponent } from '../upload-gallary-images/upload-gallary-images.component'
import { LoadingService } from 'src/app/shared/services/loading.service'

@Component({
  selector: 'app-upload-gallary-videos',
  templateUrl: './upload-gallary-videos.component.html',
  styleUrls: ['./upload-gallary-videos.component.scss']
})
export class UploadGallaryVideosComponent implements OnInit {
  accetpFiles = "image/png, image/jpeg, image/jpg"
  accetpVideos = "video/mp4"
  subscription = new Subscription()
  image!: any
  video!: any
  sizeError = false
  videoError = false
  body = {
    "url": "",
    "mediaType": 10,
    "thumbnailUrl": ""
  }
  constructor(public dialog: MatDialogRef<UploadGallaryImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { branchId: number },
    private organizationsService: OrganizationsService, private toaster: ToastrService,
    private translate: TranslateService,private loadingServ: LoadingService) { }

  ngOnInit(): void {
  }

  videoChangeEvent(event: any,) {
    this.videoError = false
    if (event?.target?.files[0]?.size <= 5000001 && this.accetpVideos.includes(event?.target?.files[0]?.type))
      this.video = event?.target?.files[0]
    else this.videoError = true
  }

  imageChangeEvent(event: any,) {
    this.sizeError = false
    if (event?.target?.files[0]?.size <= 1000001 && this.accetpFiles.includes(event?.target?.files[0]?.type))
      this.image = event?.target?.files[0]
    else this.sizeError = true
  }

  uploadThumbnail() {
    this.loadingServ.showSpinner();
    const formData = new FormData()
    formData.append('image', this.image)
    this.subscription.add(
      this.organizationsService.uploadGalleryVideoThumb(formData).subscribe((res: any) => {
        this.body.thumbnailUrl = res?.result?.url
        this.uploadVideo()
      })
    )
  }

  uploadVideo() {
    this.loadingServ.showSpinner();
    const formData = new FormData()
    formData.append('video', this.video)
    this.subscription.add(
      this.organizationsService.uploadGalleryVideo(formData).subscribe((res: any) => {
        this.body.url = res?.result?.url
        this.updateGallery()
      })
    )
  }

  updateGallery() {
    this.loadingServ.showSpinner();
    const body = {
      "branchId": this.data.branchId,
      "items": [
        {
          ...this.body
        }
      ]
    }
    this.subscription.add(
      this.organizationsService.AddToGallery(body).subscribe(res => {
        this.dialog.close(true);
        this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
      })
    )
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

}
